const ja = {
  unrepliedChargeback: "未処理チャージバック",
  unrepliedRetrieval: "リスク注文",
  unrepliedRiskTransaction: "リスク注文（未処理）",
  balance: "アカウント残高",
  accountBalance: "口座残高",
  totalUsdBalance: "口座残高合計",
  totalUsdBalanceTip: "総口座残高は、各通貨口座の「口座残高」を米ドルに換算した合計です。",
  available: "利用可能な現金の量:",
  WITHDRAW: "出金",
  frozenBalance: "冷凍量",
  rollingReserveBalance: "ローリング保証金",
  fixedReserveBalance: "固定保証金額",
  noaccount: "このグループはまだ通貨アカウントを設定していません。しばらくお待ちください。",
  allGroups: "全グループ",
  noFeeSetting: "この引き出し関連の設定は正しくありません。できるだけ早く営業にご連絡ください。",
  tradeSum: "取引概要",
  group: "グループ",
  website: "Webサイト",
  omniWebsite: "ウェブサイト・店舗",
  currency: "取引通貨",
  today: "本日の累計取引",
  successfulAmount: "取引成功金額",
  todayNumber: "成功件数",
  currentMonth: "今月の累計取引",
  accumulated: "過去の累計取引",
  settledAccount: "決済金額",
  settledNumber: "決済数",
  unsettledAccount: "未決済金額",
  unsettledNumber: "未決済取引数",
  todaySettled: "本日の累計決済額",
  todayUnsettled: "本日の未決済取引",
  monthSettled: "今月の累計決済額",
  monthUnsettled: "今月の未決済取引",
  historySettled: "過去の累積決済額",
  historyUnsettled: "過去の未決済取引",
  cbSum: "チャージバックの概要",
  cbSumTips: "チャージバックの数/金額は 1 件の拒否に基づいて計算され、チャージバックに関連する統計時間は PingPongPay システムに入力された時間に基づいて計算されます。",
  covertedUSD: "金額はあくまで参考値です。通貨別に表示したい場合は「取引通貨」を指定してください",
  cbCurrentMonth: "その月の累積チャージバック",
  cbAccumulated: "過去の累積チャージバック",
  cbAmount: "チャージバック金額",
  cbNumber: "チャージバック件数",
  acRate: "チャージバック率",
  cbWarningAmount: "チャージバックアラート金額",
  cbWarningNumber: "チャージバックアラート件数",
  tip: "金額はあくまで参考です",
  operatingGuide: "加盟店向け管理画面操作ガイド",
  guide: {
    videoTitle: "動画解説",
    textTitle: "テキスト版の資料が必要な場合は、ダウンロードしてください",
    video1: "パート 1: ホームページ",
    video2: "Part2: 取引と決済",
    video3: "Part3: 支払いの拒否",
    video4: "Part4: 現金を引き出す"
  },
  certificatePending: "文書情報を検討中です。しばらくお待ちください。"
};
export default ja;